import React, { ChangeEventHandler, KeyboardEventHandler } from 'react';
import { searchSvg } from 'components/ComponentExhibitor/AllForExhibitor';

import './SearchRow.css';

interface IExhibitorStyleSearchProps {
  value: string;
  placeholder: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
}

const ExhibitorStyleSearch = ({
  value,
  placeholder,
  onChange,
  onSearch,
}: IExhibitorStyleSearchProps) => {
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="exhibitor-style-search">
      <div
        className="search-icon"
        style={{
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          opacity: 0.5,
        }}
        onClick={onSearch}
      >
        {React.cloneElement(searchSvg as React.ReactElement, {
          style: {
            width: '20px',
            height: '20px',
            display: 'block',
          },
        })}
      </div>
      <input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default ExhibitorStyleSearch;